import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Alert,
} from "reactstrap";
import { AsistenciaPresencialService } from "service/AsistenciaPresencialService";
import FDateInput from "components/DateInput/FDateInput";

function ModalSubirAsistencia({ isOpen, toggle, data, notify }) {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fecha, setFecha] = useState(new Date().toISOString().split("T")[0]);

  const asistenciaService = new AsistenciaPresencialService();

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      alert("Por favor, seleccione un archivo.");
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);

      // El endpoint espera ciclo, tipoasistencia, fecha (ISO)
      const response = await asistenciaService.uploadExcel(
        data.ciclo,
        data.tipoasistencia,
        new Date(fecha).toISOString(),
        formData
      );

      if (response.confirmation === "success") {
        notify("success", `Procesados: ${response.resultados?.length || 0}. Errores: ${response.errores?.length || 0}`);
        toggle();
      } else {
        notify("warning", response.message || "Error al procesar el archivo.");
      }
    } catch (error) {
      console.error("Error subiendo archivo:", error);
      notify("danger", "Error al subir el archivo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Importar Asistencia desde Excel</ModalHeader>
      <ModalBody>
        <Alert color="info">
          Ciclo: <strong>{data.denominacionciclo}</strong> <br />
          Turno: <strong>{data.tipoasistencia}</strong>
        </Alert>
        <FormGroup>
          <Label for="fechaImport">Fecha de Asistencia</Label>
          <FDateInput
            id="fechaImport"
            value={fecha}
            onChange={(e) => setFecha(e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <Label for="excelFile">Archivo Excel (.xlsx, .xls)</Label>
          <Input
            type="file"
            id="excelFile"
            accept=".xlsx, .xls"
            onChange={handleFileChange}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleUpload} disabled={loading}>
          {loading ? "Procesando..." : "Subir Archivo"}
        </Button>{" "}
        <Button color="secondary" onClick={toggle}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ModalSubirAsistencia;
